var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',[_vm._v("Layers")]),_c('div',[_c('button',{on:{"click":function($event){return _vm.onNewLayer()}}},[_vm._v("New layer")])]),_c('div',_vm._l((_vm.layers),function(layer){return _c('Layer',{key:layer.name,attrs:{"layer":layer,"project":_vm.project}})}),1)])
}
var staticRenderFns = []

export { render, staticRenderFns }